import { formatDataTopicAnswer } from '@/utils';

const keywordUnicodeValidator = async (value, keywordUnicode) => {
  if (!value) return Promise.resolve();
  const arrayKeyword = keywordUnicode?.arrayKeyWord || [];
  const arrayValue = value.split('/_/').filter((item) => item !== '');
  if (arrayValue.length !== arrayKeyword.length) {
    return Promise.reject(new Error('Keyword length and keyword Unicode length do not match'));
  }
  return Promise.resolve();
};

const keywordInvalidValidator = async (value, data) => {
  if (!value) return Promise.resolve();
  const { isCheckTextKeyWord } = formatDataTopicAnswer(data?.[0]?.config_value, value);
  if (!isCheckTextKeyWord) {
    return Promise.reject(new Error('Keyword contains invalid characters'));
  }
  return Promise.resolve();
};

export { keywordUnicodeValidator, keywordInvalidValidator };
